import { BaseConnector } from '@/connectors/base.connector';
import { Video } from './video.model';

export class VideosConnector extends BaseConnector {
  constructor() {
    super('videos');
  }

  async getByBundleId(bundleId: string): Promise<Video[]> {
    return (await this.get<Video[]>(`/byBundleId?bundleId=${bundleId}`)).result;
  }
}
